class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector(".video-player");
    this.posterWrapper = this.querySelector(".poster-wrapper");
    this.srcDesktop = this.getAttribute("src-desktop");
    this.srcMobile = this.getAttribute("src-mobile");
    this.currentSrc = "";
    this.isLoaded = false;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.initObserver();
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    if (this.observer) this.observer.disconnect();
  }

  initObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoaded) {
          this.loadVideo();
          observer.unobserve(this); // Stop observing after loading
        }
      });
    }, { threshold: 0.5 }); // Load when 50% of the video banner is visible

    this.observer.observe(this);
  }

  getVideoSource() {
    return window.innerWidth > 767 ? this.srcDesktop : this.srcMobile;
  }

  loadVideo() {
    const newSrc = this.getVideoSource();
    if (newSrc !== this.currentSrc) {
      this.video.src = newSrc;
      this.currentSrc = newSrc;
      this.video.load();
      this.video.play().then(() => {
        this.posterWrapper.style.display = "none"; // Hide placeholder on play
        this.isLoaded = true;
      }).catch(err => console.error("Video play failed:", err));
    }
  }

  handleResize() {
    if (this.isLoaded) this.loadVideo();
  }
}

customElements.define("lazy-video", LazyVideo);